import { ArticleIcon } from "@/components/app-icons/Article";
import { WorkHistoryIcon } from "@/components/app-icons/Briefcase";
import { CompanyIcon } from "@/components/app-icons/Buildings";
import { SuccessIcon } from "@/components/app-icons/CheckCircle";
import { CelebrationIcon } from "@/components/app-icons/Confetti";
import { LocationIcon } from "@/components/app-icons/MapPin";
import { MicrophoneIcon } from "@/components/app-icons/Microphone";
import { SellIcon, StoreIcon } from "@/components/app-icons/Storefront";
import type { AppIcon } from "@/components/createAppIcon";

const COMPANY_BADGE_ICON_BY_KEY: Record<string, AppIcon> = {
  distributor: StoreIcon,
  distribution: StoreIcon,
  festival: CelebrationIcon,
  imprint_label: SellIcon,
  manufacturer: CompanyIcon,
  manufacturing: CompanyIcon,
  pressing_plant: CompanyIcon,
  production_company: WorkHistoryIcon,
  production_place: MicrophoneIcon,
  publisher: ArticleIcon,
  publishing: ArticleIcon,
  record_label: SellIcon,
  recording_studio: MicrophoneIcon,
  retailer: StoreIcon,
  rights_society: SuccessIcon,
  venue: LocationIcon,
};

export function getCompanyBadgeIcon(value: string): AppIcon {
  return COMPANY_BADGE_ICON_BY_KEY[value] ?? CompanyIcon;
}
